/**
 * @author Jersson Stiven Morales Alza
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import {
    manejadorDialogoGlobal,
    manejadorIndicadorCargaGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import ITiposClientes from 'Infotrack@Modelos/smartStock/tiposClientes/entidades/tiposClientes';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';
import React from 'react';
import { useSelector } from 'react-redux';
import TiposClientesCM from '../controladorModelo/tiposClientesCM';
import { acciones, IEstadoTiposClientes } from '../reductorTiposClientes';
import TiposClientesVista from '../vista/tablaTiposClientesVista';

const tiposClientesCM = new TiposClientesCM();

const TableTiposClientesCV: React.FunctionComponent = () => {
    const cargaInicial = React.useRef(true);
    const [tiposClientes, setTiposClientes] = React.useState<ITiposClientes[]>([]);
    const [{ recargarTabla }, dispatch] = useProveedor<IEstadoTiposClientes>();
    const idEmpresa = useSelector((estado: IEstadoGlobal) => estado.estadoAutenticacion.usuarioInformacion!.IdEmpresa);

    React.useEffect(() => {
        if (recargarTabla || cargaInicial.current) {
            cargarTiposClientes();
            if (recargarTabla) {
                dispatch({ type: acciones.RECARGAR_TABLA });
            }
        }
        cargaInicial.current = false;
    });

    const cargarTiposClientes = () => {
        manejadorIndicadorCargaGlobal(true);
        tiposClientesCM.consultarListaTiposClientePorEmpresaId(idEmpresa).then((tiposClientesCargados) => {
            setTiposClientes(tiposClientesCargados);
            manejadorIndicadorCargaGlobal(false);
        });
    };
    const manejarFormulario = (tipoFormulario: TipoFormulario, entidadTiposClientes?: ITiposClientes) => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: { entidadTiposClientes, tipoFormulario } });
    };

    const confirmarEliminacion = (tipoCliente: ITiposClientes) => {
        manejadorDialogoGlobal({
            accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
            accionConfirmar: () => eliminarTiposClientes(tipoCliente),
            estado: true,
            mensaje: <Texto id={'alerta.confirmacionEliminacion'} />,
            mostrarCancelar: true,
            tipoDialogo: 'Advertencia',
            titulo: <Texto id="titulo.advertencia" />,
        });
    };

    const eliminarTiposClientes = (tipoCliente: ITiposClientes) => {
        manejadorIndicadorCargaGlobal(true);
        manejadorDialogoGlobal({ estado: false });
        tiposClientesCM.eliminarTiposClientes(tipoCliente).then(() => {
            manejadorIndicadorCargaGlobal(false);
            dispatch({ type: acciones.RECARGAR_TABLA });
        });
    };

    return (
        <TiposClientesVista
            tiposClientess={tiposClientes}
            cargarTiposClientes={cargarTiposClientes}
            confirmarEliminacion={confirmarEliminacion}
            manejarFormulario={manejarFormulario}
        />
    );
};

export default TableTiposClientesCV;
